import { defineMessages } from 'react-intl';

export default defineMessages({
  errorTitle: { defaultMessage: 'Network connection error' },
  errorDescription: {
    defaultMessage: 'Please wait a few seconds or try to reload the page manually.',
  },
});
